import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { usersService } from '../services/usersService'

export const useReferral = () => {
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['userReferral'],
    queryFn: async () => usersService.getReferral(),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
  }
}
